<app-confirm-modal></app-confirm-modal>

<mat-drawer-container
  class="container sidenav-container {{ navbarService.layoutClass }} {{
    themesService.themeClass
  }}">
  <mat-drawer
    class="mat-drawer-sidebar"
    [mode]="navbarService.modeMenu"
    [attr.role]="navbarService.isDesktop ? 'dialog' : 'navigation'"
    [opened]="navbarService.isOpenedMenu"
    (closedStart)="navbarService.closeMenu()">
    <app-sidebar #sidebarComponent></app-sidebar>
  </mat-drawer>
  <mat-drawer-content
    class="{{ navbarService.layoutClass }} {{ themesService.themeClass }}">
    @if (authenticationService.showSidebar()) {
      <mat-toolbar
        color="primary"
        class="menu-logo-toolbar {{ navbarService.layoutClass }} {{
          themesService.themeClass
        }}">
        <div class="menu-logo-toolbar-container">
          <button
            mat-button
            type="button"
            class="menu-button"
            (click)="navbarService.openMenu()">
            <img src="assets/img/dashboard/lines.svg" />
          </button>
          <h1
            class="p-header__company"
            (click)="sidebarComponent.openHomePage()">
            <img
              [src]="
                authenticationService.getProfileState().themeLogoUrl ||
                themesService.logoSrc
              "
              class="sidenav-sidenav__logo"
              [class.sidenav-sidenav__logo--custom]="
                !!authenticationService.getProfileState().themeLogoUrl
              "
              [attr.alt]="themesService.logoAlt || 'Logo'" />
          </h1>
        </div>
      </mat-toolbar>
    }
    <div
      class="content-wrapper {{ navbarService.layoutClass }} {{
        themesService.themeClass
      }}"
      [class.page-body]="authenticationService.showSidebar()">
      <router-outlet></router-outlet>
    </div>
    @if (showFooter()) {
      <app-footer
        class="{{ navbarService.layoutClass }} {{ themesService.themeClass }}"
        [class.page-footer]="authenticationService.showSidebar()"></app-footer>
    }
  </mat-drawer-content>
</mat-drawer-container>
